import * as z from "zod/v4-mini";

// DocumentReferenceのスキーマ（Firestoreの参照型）
const documentReferenceSchema = z.object({
  id: z.string(),
  path: z.string(),
});

// EventVideoGroupのスキーマ
export const EventVideoGroupSchema = z.object({
  _id: z.string(),
  _refPath: z.string(),
  eventId: z.string(),
  name: z.string(),
  priority: z.number(),
  videoGroupsSetRef: documentReferenceSchema,
});

export type EventVideoGroup = z.infer<typeof EventVideoGroupSchema>;

// EventVideoGroupsSetのスキーマ
export const EventVideoGroupsSetSchema = z.object({
  _id: z.string(),
  _refPath: z.string(),
  name: z.string(),
  priority: z.number(),
  mainVideoRef: documentReferenceSchema,
});

export type EventVideoGroupsSet = z.infer<typeof EventVideoGroupsSetSchema>;

export const FeatureFlagSchema = z.object({
  _id: z.string(),
  _refPath: z.string(),
  globalEnabled: z.boolean(),
  events: z.record(z.string(), z.boolean()),
});

export type FeatureFlag = z.infer<typeof FeatureFlagSchema>;
